// src/components/Sidebar.js
import React from "react";
import { Link } from "react-router-dom";

const Sidebar = () => {
  return (
    <div className="bg-gray-900 text-white w-64 h-screen fixed top-0 left-0 flex flex-col p-6 space-y-6">
      <h2 className="text-2xl font-bold">BYN Admin</h2>

      <nav className="flex flex-col space-y-4 text-lg">
        {/* =================== Dashboard =================== */}
        <span className="text-yellow-400 font-semibold uppercase text-sm">
          Dashboard
        </span>
        <Link to="/admin/dashboard" className="hover:text-yellow-400">
          📊 Admin Dashboard
        </Link>

        {/* =================== Users =================== */}
        <span className="text-yellow-400 font-semibold uppercase text-sm mt-4">
          Users
        </span>
        <Link to="/admin/workers" className="hover:text-yellow-400">
          🛠️ Manage Workers
        </Link>
        <Link to="/admin/customers" className="hover:text-yellow-400">
          👤 View Customers
        </Link>

        {/* =================== Operations =================== */}
        <span className="text-yellow-400 font-semibold uppercase text-sm mt-4">
          Operations
        </span>
        <Link to="/admin/manage-jobs" className="hover:text-yellow-400">
          📋 Manage Jobs
        </Link>
        <Link to="/admin/manage-rides" className="hover:text-yellow-400">
          🚗 Manage Rides
        </Link>
        <Link to="/admin/ride-documents" className="hover:text-yellow-400">
          🧾 Ride Documents
        </Link>

        {/* =================== Support & Help =================== */}
        <span className="text-yellow-400 font-semibold uppercase text-sm mt-4">
          Support & Help
        </span>
        <Link to="/admin/support/live-chat" className="hover:text-yellow-400">
          💬 Live Support Chat
        </Link>
        <Link to="/admin/support/tickets" className="hover:text-yellow-400">
          📩 Support Tickets
        </Link>
        <Link to="/admin/disputes" className="hover:text-yellow-400">
          ⚖️ Dispute Jobs
        </Link>
        <li>
  <Link
    to="/admin/send-email"
    className="flex items-center gap-3 px-4 py-2 hover:bg-gray-700 rounded"
  >
    📧 <span>Send Email</span>
  </Link>
</li>

      </nav>

      {/* =================== Logout =================== */}
      <div className="mt-auto">
        <button
          className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded"
          onClick={() => {
            localStorage.removeItem("adminToken");
            window.location.href = "/";
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
